<script setup lang="ts">
import { getCSSVariable } from '@/helpers/utils'

interface Props {
  title: string
  backgroundColor: string
}

withDefaults(defineProps<Props>(), {
  backgroundColor: getCSSVariable('ui-green'),
})
</script>

<template>
  <div class="gs-card" :style="{ backgroundColor }">
    <div class="gs-card-header">
      <h3 class="gs-card-title">{{ title }}</h3>
    </div>
    <div class="gs-card-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gs-card {
  position: relative;
  color: var(--lightest);
  border-radius: 5px;
  padding: 24px;

  @include media('md-and-up') {
    padding: 35px;
  }
}

.gs-card-title {
  font-size: 32px;
  font-weight: 700;

  @include media('md-and-up') {
    font-size: 40px;
  }
}

.gs-card-content {
  font-size: 20px;

  @include media('md-and-up') {
    font-size: 24px;
  }

  :deep(ul) {
    list-style-type: disc;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 25px;
  }
}
</style>
